<template>
  <div>
    <segment-form :segment="localSegment"
                  :title="`${$t('generic.edit')} ${localSegment.name}`"
                  class="-mx-3"
                  @submit="updateSegment"/>

    <section-separator size="lg" has-border class="mb-3">
      {{$t('settings.segments.title')}}
    </section-separator>
    <data-table :service="SegmentService"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="delete,add,refresh"
                :sync-route="false"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :clickable="false"
                @on-add="addSegmentRow"
                ref="table">
      <template slot="extra-buttons" slot-scope="{row, index}">
        <base-button class="mr-2"
                     outline
                     @click.stop="addSegmentRow(row, index)" type="info" icon size="sm">
          <i class="fas fa-clone"></i>
        </base-button>
      </template>
      <template slot="value" slot-scope="{row, index}">
        <editable-grid-cell :value="row.value"
                            :show-input="!row.id"
                            :editable="true"
                            placeholder="Value"
                            @keyup.enter="trySave(row, index)"
                            @change="(val) => updateSegmentRow(val, 'value', row, index)">
          {{row.value}}
        </editable-grid-cell>
      </template>
    </data-table>
  </div>
</template>
<script>
  import SegmentGroupService from 'src/services/SegmentGroupService'
  import SegmentService from 'src/services/SegmentService'
  import SegmentForm from './SegmentForm'
  import EditableGridCell from 'src/components/EditableGridCell';
  import entities from 'src/config/entities'

  export default {
    name: 'segments-edit',
    components: {
      SegmentForm,
      EditableGridCell,
    },
    props: {
      segment: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        SegmentGroupService,
        SegmentService,
        entity: entities.SEGMENT,
        localSegment: {},
        saving: false
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "value",
            label: 'Value',
            minWidth: "120px",
          }
        ]
      },
      filters() {
        return [{ key: 'match[segment_group_id]', value: this.$route.params.id }]
      }
    },
    methods: {
      async updateSegment(data) {
        await SegmentGroupService.update(data.id, data);
        this.$router.push({name: 'settings_segments-groups'});
      },
      async saveSegment(row, index = 0) {
        let result = await SegmentService.create(row);
        this.$refs.table.tableData.splice(index, 1, result.data);
      },
      async trySave(row, index) {
        if(!row.id) {
          await this.saveSegment(row, index)
        }
      },
      async updateSegmentRow(evt, key, row, index = 0) {
        let value = evt.target.value;
        this.saving = true;
        let id = row.id;
        if (id) {
          let data = {
            ...row,
            [key]: value
          };
          await SegmentService.update(id, data);
          row[key] = value;
        } else {
          row[key] = value;
        }
        this.saving = false;
      },
      async addSegmentRow(rowData = {}, index = 0) {
        let row = {
          segment_group_id: parseInt(this.$route.params.id),
          ...rowData
        };
        delete row.id;
        this.$refs.table.tableData.splice(index, 0, row);
      }
    },
    async created () {
      this.$watch('segment', newVal => {
        this.localSegment = {
          ...newVal
        }
      }, { immediate: true });
    }
  }
</script>
